import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { KeyValueOpt } from 'src/app/shared/models/keyvalue.model';

@Component({
    selector: 'app-radiobutton-list',
    templateUrl: './radiobutton-list.component.html',
    styleUrls: ['./radiobutton-list.component.scss']
,  standalone: false
})
export class RadiobuttonListComponent implements OnInit {
    @Input() isInline: boolean = false;
    @Input() dataList: KeyValueOpt<string, string, boolean>[] = [];
    @Output() selectedOptions: EventEmitter<KeyValueOpt<string, string, boolean>[]> = new EventEmitter();

    listName = "rl" + (new Date()).getMilliseconds;

    ngOnInit() {
        //This blank function is mandatory.
    }

    selectOption(event, dt: KeyValueOpt<string, string, boolean>) {
        if (event.target.checked) {
            dt.opt = true
        }
        else {
            dt.opt = false
        }
        this.dataList.forEach(x => {
            if (x.key != dt.key) {
                x.opt = false;
            }
            else {
                x.opt = true;
            }
        });
        this.selectedOptions.emit(this.dataList);        
    }
}
